import ClientChatMessage from './clientChatMessage';
import User from '@/models/user';
import { ClientChatProps } from '@/interfaces/models/clientChat';
import { ClientChatMessageProps } from '@/interfaces/models/clientChatMessage';

export default class ClientChat {
  public client: any;
  public id: string;
  public messages: ClientChatMessage[] = [];
  public place: string;

  constructor(clientChatProps: ClientChatProps) {
    this.client = clientChatProps.client;
    this.id = clientChatProps.id;

    if (clientChatProps.messages) {
      this.messages = clientChatProps.messages.map((clientChatMessageProps: ClientChatMessageProps) => {
        return new ClientChatMessage(clientChatMessageProps);
      });
    }

    this.place = clientChatProps.place;
  }

  public static isSameOwners(firstOwner: any | null, secondOwner: any | null) {
    return firstOwner === secondOwner
      || (firstOwner !== null && secondOwner !== null && firstOwner.id === secondOwner.id);
  }

  get chatBlocks() {
    const blocks: { [key: string]: ClientChatMessage[][] } = {};

    for (let index = 0; index < this.messages.length; index++) {
      const messageHash = this.messages[index].date.getHumanDateString();
      const currentBlock = blocks[messageHash];

      if (!currentBlock) {
        blocks[messageHash] = [ [ this.messages[index] ] ];
      } else {
        const lastChatBlock = currentBlock[currentBlock.length - 1];

        if (ClientChat.isSameOwners(lastChatBlock[0].staff, this.messages[index].staff)) {
          lastChatBlock.push(this.messages[index]);
        } else {
          currentBlock.push([
            this.messages[index]
          ]);
        }
      }
    }

    return blocks;
  }

  addMessage(message: ClientChatMessage) {
    this.messages.push(message);
  }
}
